import { render } from "./PortfolioBalancerReportPage.vue?vue&type=template&id=336ab431&scoped=true&ts=true"
import script from "./PortfolioBalancerReportPage.vue?vue&type=script&lang=ts"
export * from "./PortfolioBalancerReportPage.vue?vue&type=script&lang=ts"

import "./PortfolioBalancerReportPage.vue?vue&type=style&index=0&id=336ab431&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336ab431"]])

export default __exports__